import React, { useState } from 'react';

// Ordinamento per colonna a 3 stati (predefinito -> crescente -> decrescente -> predefinito),
// al posto di un menu a tendina "Ordina per". "Predefinito" = ordine cosi' come arriva
// dall'API (gia' filtrato), senza alcun sort applicato.
export function useSort() {
  const [sort, setSort] = useState({ key: null, dir: null });
  const onSort = (key) => {
    setSort((s) => {
      if (s.key !== key) return { key, dir: 'asc' };
      if (s.dir === 'asc') return { key, dir: 'desc' };
      return { key: null, dir: null };
    });
  };
  return [sort, onSort];
}

// accessors: { [key]: { get: (row) => value, type: 'string'|'number'|'date' } }
export function sortRows(rows, sort, accessors) {
  if (!sort.key) return rows;
  const acc = accessors[sort.key];
  if (!acc) return rows;
  const { get, type } = acc;
  const sign = sort.dir === 'asc' ? 1 : -1;
  return [...rows].sort((a, b) => {
    const va = get(a);
    const vb = get(b);
    if (va == null && vb == null) return 0;
    if (va == null) return 1;
    if (vb == null) return -1;
    let cmp;
    if (type === 'number') cmp = Number(va) - Number(vb);
    else if (type === 'date') cmp = new Date(va).getTime() - new Date(vb).getTime();
    else cmp = String(va).localeCompare(String(vb), 'it', { sensitivity: 'base', numeric: true });
    return cmp * sign;
  });
}

function SortableTh({ label, sortKey, sort, onSort, className, style }) {
  return (
    <th className={`sortable-th${className ? ` ${className}` : ''}`} style={style} onClick={() => onSort(sortKey)}>
      {label}
    </th>
  );
}

export default SortableTh;
